import { render } from "./ModalConvidarUsuario.vue?vue&type=template&id=be119f92&scoped=true"
import script from "./ModalConvidarUsuario.vue?vue&type=script&lang=js"
export * from "./ModalConvidarUsuario.vue?vue&type=script&lang=js"

import "./ModalConvidarUsuario.vue?vue&type=style&index=0&id=be119f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be119f92"]])

export default __exports__